import axiosIns from "@/libs/axios";

export async function login(...args) {
  await axiosIns.post("/auth/login", ...args);
}
